import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useOrg } from '../context/OrgContext';
import { usePermissions } from '../components/PermissionGuard';
import { PageHeader } from '../components/PageHeader';

export function Dashboard() {
  const { user } = useAuth();
  const { selectedOrg, orgRole, orgs } = useOrg();
  const permissions = usePermissions();

  return (
    <div style={styles.container}>
      <PageHeader 
        title={`Welcome, ${user?.name}`}
        subtitle={`You are signed in as ${formatRole(orgRole)} for ${selectedOrg?.name}`}
      />
      
      <div style={styles.grid}>
        <div style={styles.infoCard}>
          <h3>Session Info</h3>
          <dl style={styles.dl}>
            <dt>User ID</dt>
            <dd>{user?.id}</dd>
            <dt>Email</dt>
            <dd>{user?.email}</dd>
            <dt>Organization</dt>
            <dd>{selectedOrg?.name} ({selectedOrg?.id})</dd>
            <dt>Role in Org</dt>
            <dd>{formatRole(orgRole)}</dd>
            <dt>Org Plan</dt>
            <dd style={{ textTransform: 'capitalize' }}>{selectedOrg?.plan}</dd>
          </dl>
        </div>

        <div style={styles.infoCard}>
          <h3>Your Permissions</h3>
          <ul style={styles.permList}>
            {Object.entries(permissions).map(([key, value]) => (
              <li key={key} style={styles.permItem}>
                <span>{formatPermKey(key)}</span>
                <span style={{
                  ...styles.permBadge,
                  background: value ? '#c6f6d5' : '#fed7d7',
                  color: value ? '#276749' : '#c53030'
                }}>
                  {value ? 'Yes' : 'No'}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {orgs.length > 1 && (
        <div style={{ ...styles.infoCard, marginTop: '1.5rem' }}>
          <h3>Your Organizations</h3>
          <ul style={styles.orgList}>
            {orgs.map(org => (
              <li key={org.id} style={styles.orgItem}>
                <span style={styles.orgItemName}>{org.name}</span>
                <span style={styles.orgItemRole}>{formatRole(org.role)}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

function formatRole(role) {
  if (!role) return '';
  return role.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

function formatPermKey(key) {
  return key.replace(/^can/, '').replace(/([A-Z])/g, ' $1').trim();
}

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '1000px',
    margin: '0 auto'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '1.5rem'
  },
  infoCard: {
    background: 'white',
    borderRadius: '8px',
    padding: '1.5rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  },
  dl: {
    display: 'grid',
    gridTemplateColumns: '120px 1fr',
    gap: '0.5rem 1rem',
    marginTop: '1rem'
  },
  permList: {
    listStyle: 'none',
    padding: 0,
    marginTop: '1rem'
  },
  permItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.375rem 0',
    fontSize: '0.875rem'
  },
  permBadge: {
    padding: '0.125rem 0.5rem',
    borderRadius: '4px',
    fontSize: '0.75rem',
    fontWeight: '500'
  },
  orgList: {
    listStyle: 'none',
    padding: 0,
    marginTop: '1rem'
  },
  orgItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.5rem 0',
    borderBottom: '1px solid #e2e8f0'
  },
  orgItemName: {
    fontWeight: '500'
  },
  orgItemRole: {
    color: '#718096'
  }
};
